import classNames from "classnames";

export function Arrow({ fillColor, className }: { fillColor?: string, className?: string }) {
  return (
    <svg className={classNames(className)} width="12" height="7" viewBox="0 0 12 7" fill={fillColor} xmlns="http://www.w3.org/2000/svg">
      <path d="M6.00001 6.20005C5.53335 6.20005 5.06668 6.02005 4.71335 5.66672L0.36668 1.32005C0.173346 1.12672 0.173346 0.806717 0.36668 0.613384C0.560013 0.42005 0.880013 0.42005 1.07335 0.613384L5.42001 4.96005C5.74001 5.28005 6.26001 5.28005 6.58001 4.96005L10.9267 0.613384C11.12 0.42005 11.44 0.42005 11.6333 0.613384C11.8267 0.806717 11.8267 1.12672 11.6333 1.32005L7.28668 5.66672C6.93335 6.02005 6.46668 6.20005 6.00001 6.20005Z" />
    </svg>
  )
}